import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { SidebarData1 } from "../../core/json/sidebar_dataone";

const HorizontalSidebar = () => {
  const [opendSubMenu, setOpendSubMenu] = useState([null, null]);
  const sidebarRef = useRef(null);
  const location = useLocation();

  // const navigate = useNavigate();
  const currentPath = location.pathname.split("/")[1];
  const roleId = parseInt(sessionStorage.getItem("selectedRole"));

  const showMenu = (title) => {
    setOpendSubMenu((prevState) =>
      prevState[0] === title ? [null, null] : [title, null]
    );
  };

  const showSubMenu = (title) => {
    setOpendSubMenu((prevState) =>
      prevState[1] === title ? [prevState[0], null] : [prevState[0], title]
    );
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setOpendSubMenu([null, null]);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter menu by current path
  const filteredMenu = Object.keys(SidebarData1).find((key) =>
    location.pathname.startsWith(`/${key}`)
  )
    ? SidebarData1[currentPath]
    : [];

  // Filter out User Permissions menu for admin (roleId = 1)
  // or show only if roleId !== 1
  const filteredMenuByRole = filteredMenu
    .map((menuItem) => {
      // Restrict "Admin" and "Masters" sections to only roleId === 1 (Admin)
      if (["Admin", "Master"].includes(menuItem.tittle) && roleId !== 1) {
        return null; // Skip this menu item for non-admins
      }

      if (menuItem.subRoutes && menuItem.subRoutes.length > 0) {
        const filteredSubRoutes = menuItem.subRoutes.filter((subItem) => {
          if (
            ["User Permissions", "Role Permissions", "Users"].includes(
              subItem.tittle
            )
          ) {
            if (subItem.tittle === "User Permissions" && roleId === 1)
              return true;
            if (subItem.tittle === "Role Permissions" && roleId === 1)
              return true;
            if (subItem.tittle === "Users" && roleId === 1) return true;
            return false;
          }
          return true;
        });

        return {
          ...menuItem,
          subRoutes: filteredSubRoutes,
        };
      }

      return menuItem;
    })
    .filter((item) => {
      // Skip nulls from Admin/Masters block above
      if (!item) return false;

      // Remove if subRoutes are now empty
      if (
        item.hasSubRoute &&
        (!item.subRoutes || item.subRoutes.length === 0)
      ) {
        return false;
      }

      return true;
    });

  const isActiveMainMenu = (mainMenus) => {
    const currentPath = location.pathname || "";
    return (
      (mainMenus.route &&
        currentPath.split("/")[1] === mainMenus.route.split("/")[1]) ||
      mainMenus.subRoutes?.some(
        (subMenu) =>
          subMenu.route &&
          currentPath.split("/")[1] === subMenu.route.split("/")[1]
      )
    );
  };

  const isActiveSubMenu = (mainMenus) => {
    const currentPath = location.pathname || "";
    return (
      (mainMenus.route &&
        currentPath.split("/")[1] === mainMenus.route.split("/")[1]) ||
      mainMenus.subRoutes?.some(
        (subMenu) =>
          subMenu.route &&
          currentPath.split("/")[1] === subMenu.route.split("/")[1]
      )
    );
  };

  useEffect(() => {
    // Close open menus on route change
    setOpendSubMenu([null, null]);
  }, [location.pathname]);

  // Sign out handler
  // const handleSignOut = () => {
  //   sessionStorage.clear();
  //   navigate("/signin");
  // };

  return (
    <>
      {roleId !== 3 && (
        <div
          className="sidebar sidebar-horizontal"
          id="horizontal-menu"
          ref={sidebarRef}
        >
          <div className="sidebar-menu" id="sidebar-menu-3">
            <div className="main-menu">
              <ul className="nav">
                {filteredMenuByRole?.map((mainTittle, mainIndex) => (
                  <li className="submenu" key={mainIndex}>
                    <NavLink
                      to={mainTittle.route}
                      className={`${
                        opendSubMenu[0] === mainTittle.tittle ||
                        isActiveMainMenu(mainTittle)
                          ? "active"
                          : ""
                      }`}
                      onClick={() => showMenu(mainTittle.tittle)}
                    >
                      {mainTittle.tittle === "Components" ? (
                        <i className="feather icon-layers fs-3"></i>
                      ) : (
                        <i className={`ti ti-${mainTittle.icon} me-2`}></i>
                      )}
                      <span>{mainTittle.tittle}</span>
                      {mainTittle.hasSubRoute ? (
                        <span className="menu-arrow"></span>
                      ) : (
                        ""
                      )}
                    </NavLink>
                    {mainTittle?.hasSubRoute &&
                      mainTittle?.subRoutes?.length > 0 && (
                        <ul
                          className={`submenus-two ${
                            opendSubMenu[0] === mainTittle?.tittle
                              ? "d-block"
                              : "d-none"
                          }`}
                        >
                          {mainTittle?.subRoutes?.map(
                            (mainMenus, menuIndex) => (
                              <React.Fragment key={menuIndex}>
                                {!mainMenus.hasSubRoute && (
                                  <li>
                                    <NavLink
                                      to={mainMenus.route}
                                      onClick={() =>
                                        setOpendSubMenu([null, null])
                                      }
                                      className={({ isActive }) =>
                                        isActive ? "active" : ""
                                      }
                                    >
                                      <span>{mainMenus.tittle}</span>
                                    </NavLink>
                                  </li>
                                )}
                                {mainMenus.hasSubRoute && (
                                  <li className="submenu">
                                    <a
                                      className={`${
                                        isActiveSubMenu(mainMenus)
                                          ? "active"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        showSubMenu(mainMenus.tittle)
                                      }
                                    >
                                      <span>{mainMenus.tittle}</span>
                                      <span className="menu-arrow"></span>
                                    </a>
                                    <ul
                                      className={`submenus-two ${
                                        opendSubMenu[1] === mainMenus.tittle
                                          ? "d-block"
                                          : "d-none"
                                      }`}
                                    >
                                      {mainMenus.subRoutes?.map(
                                        (subDropMenus, subIndex) => (
                                          <li
                                            key={subIndex}
                                            className="submenu"
                                          >
                                            {subDropMenus.hasSubRoute ? (
                                              <>
                                                <a
                                                  className={`${
                                                    isActiveSubMenu(
                                                      subDropMenus
                                                    )
                                                      ? "active"
                                                      : ""
                                                  }`}
                                                  onClick={() =>
                                                    showSubMenu(
                                                      subDropMenus.tittle
                                                    )
                                                  }
                                                >
                                                  <span>
                                                    {subDropMenus.tittle}
                                                  </span>
                                                  <span className="menu-arrow"></span>
                                                </a>
                                                <ul
                                                  className={`submenus-two ${
                                                    opendSubMenu[1] ===
                                                    subDropMenus.tittle
                                                      ? "d-block"
                                                      : "d-none"
                                                  }`}
                                                >
                                                  {subDropMenus.subRoutes?.map(
                                                    (childMenu, childIndex) => (
                                                      <li key={childIndex}>
                                                        <NavLink
                                                          to={childMenu.route}
                                                          onClick={() =>
                                                            setOpendSubMenu([
                                                              null,
                                                              null,
                                                            ])
                                                          }
                                                          className={({
                                                            isActive,
                                                          }) =>
                                                            isActive
                                                              ? "active"
                                                              : ""
                                                          }
                                                        >
                                                          {childMenu.tittle}
                                                        </NavLink>
                                                      </li>
                                                    )
                                                  )}
                                                </ul>
                                              </>
                                            ) : (
                                              <NavLink
                                                to={subDropMenus.route}
                                                onClick={() =>
                                                  setOpendSubMenu([null, null])
                                                }
                                                className={({ isActive }) =>
                                                  isActive ? "active" : ""
                                                }
                                              >
                                                {subDropMenus.tittle}
                                              </NavLink>
                                            )}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </li>
                                )}
                              </React.Fragment>
                            )
                          )}
                        </ul>
                      )}
                  </li>
                ))}
              </ul>
            </div>

            {/* Sign Out Button */}
            {/* <div className="text-center mt-3">
          <button
            className="btn btn-danger btn-sm"
            onClick={handleSignOut}
            style={{ width: "100%", margin: "auto" }}
          >
            Sign Out
          </button> */}
            {/* </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default HorizontalSidebar;
